import { CampoDeFicha } from "@/componentes/personas/CampoDeFicha"
import type { Editor } from "@/componentes/personas/persona"
import { FECHA_MAXIMA, FECHA_MINIMA } from "@/lib/fechas"

/**
 * Identificación fiscal y perfil profesional: lo que llenan la cédula, el RIF y la
 * síntesis curricular (19/10).
 *
 * ⚠ **Los vencimientos están para verse venir.** Una cédula o un RIF vencidos son un
 * hueco del expediente: el día que lo pida un ente, no puede ser una sorpresa.
 *
 * ⚠ **El RIF lo normaliza el servidor** («v-12345678-9» → «V123456789»), así que aquí
 * se teclea como se quiera.
 */
export function PerfilDePersona({ valor, poner }: Editor) {
  const campo = (
    id: string,
    etiqueta: string,
    nombre: Parameters<Editor["valor"]>[0],
    tipo = "text",
  ) => (
    <CampoDeFicha id={id} etiqueta={etiqueta}>
      <input
        id={id}
        type={tipo}
        className={tipo === "date" ? "campo tabular-nums" : "campo"}
        min={tipo === "date" ? FECHA_MINIMA : undefined}
        max={tipo === "date" ? FECHA_MAXIMA : undefined}
        value={valor(nombre)}
        onChange={(e) => poner(nombre, e.target.value)}
      />
    </CampoDeFicha>
  )

  return (
    <section>
      <h3 className="rotulo mb-3">Identificación y perfil</h3>
      <div className="grid gap-3 sm:grid-cols-2">
        {campo("p-rif", "RIF", "rif")}
        {campo("p-rif-vence", "RIF vence", "rif_vence", "date")}
        {campo("p-cedula-vence", "Cédula vence", "cedula_vence", "date")}
        {campo("p-nacionalidad", "Nacionalidad", "nacionalidad")}
        <div className="sm:col-span-2">
          {campo("p-profesion", "Profesión u oficio", "profesion")}
        </div>
        <div className="sm:col-span-2">
          <CampoDeFicha id="p-resumen" etiqueta="Idiomas, habilidades y otros datos del currículo">
            <textarea
              id="p-resumen"
              rows={3}
              className="campo"
              value={valor("resumen_curricular")}
              onChange={(e) => poner("resumen_curricular", e.target.value)}
            />
          </CampoDeFicha>
        </div>
      </div>
    </section>
  )
}
